import { S3 } from './Aws/S3'

export const AwsApi = {
  S3
}
